import { FormGroup, ValidationErrors } from '@angular/forms';

export function confirmPassword(form: FormGroup): ValidationErrors | null {
  const password = form.controls['password'] ?? form.controls['newPassword'];
  const passwordRetyped = form.controls['passwordRetyped'];
  const errors = { password: true };

  if (password?.value === passwordRetyped?.value) return null;

  passwordRetyped?.setErrors(errors);
  return errors;
}
